import React from "react";
import IndianSocket from "./IndianSocket";
import CurtainIcon from "../../assets/Icons/CurtainIcon";
import MasterSwitchIcon from "../../assets/Icons/MasterSwitchIcon";
import FanIcon from "../../assets/Icons/FanIcon";
import Rj11 from "./Rj11";
import Rj45 from "./Rj45";
import Usb from "./Usb";
import TvSocket from "./TvSocket";
import UniversalSocket from "./UniversalSocket";
import { generateUniqueId, getAccuratePixels } from "../../utils/global";
import IconSwitch from "./IconSwitch";
import { ReactComponent as Icons103 } from "../../assets/Icons/SwitchIcons/Icons-103.svg";
import { ReactComponent as Icons31 } from "../../assets/Icons/SwitchIcons/Blind-1.svg";
import { ReactComponent as Blind } from "../../assets/Icons/SwitchIcons/Blind.svg";
import { ReactComponent as Fan8 } from "../../assets/Icons/SwitchIcons/Fan-8.svg";
import { ReactComponent as Plus } from "../../assets/Icons/plus.svg";
import { ReactComponent as Minus } from "../../assets/Icons/minusIcon.svg";
import Knob from "./Knob";
import InternationalSocket from "./InternationalSocket";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import { useDraggable } from "../../context/DrabbleContext";

function Switch({
  accessory,
  type,
  isDownloadMode,
  selectedIcons,
  downloadAs,
  handleSetSelectIcon,
  deleteSelectedicon,
  uid,
  content,
  itemKey,
  setContent,
  frame,
}) {
  const { handleTouchEnd, handleTouchMove, dragDataRef } = useDraggable();

  const renderAccessory = ({ type, id, ...item }, pId) => {
    const isDownloadIcon = downloadAs == "icon-png" || downloadAs == "pdf";
    const { left, top, right, bottom } = item;

    const dTop = isDownloadMode ? top : getAccuratePixels(top);
    const dLeft = isDownloadMode ? left : getAccuratePixels(left);

    const dRight = isDownloadMode ? right : getAccuratePixels(right);
    const dBottom = isDownloadMode ? bottom : getAccuratePixels(bottom);

    const isDownloadPng =
      downloadAs == "icon-png" || downloadAs == "cutout-png";

    const iconDimansion = isDownloadMode ? 80 : getAccuratePixels(80);

    const getContentFromKeys = (key) => {
      return content?.find((item) => item.key == key)?.data;
    };

    const setContentFromKeys = (key, data) => {
      let updatedContent = content.map((item) => {
        if (item?.key == key) {
          return {
            ...item,
            data: data,
          };
        }
        return item;
      });

      setContent(updatedContent);
    };

    if (type == "2m_insider") {
      const width = isDownloadMode ? 567 : getAccuratePixels(567);
      const height = isDownloadMode ? 657 : getAccuratePixels(657);

      const getBorder = () => {
        if (downloadAs == "pdf") {
          return "";
        }

        if (downloadAs == "cutout-png") {
          return "1px solid black";
        }

        if (downloadAs == "icon-png") {
          return "";
        }

        return "2px solid #6495ED";
      };

      // return list?.map((item) => {
      return (
        <div
          key={item?.uid}
          id={id}
          style={{
            width: width,
            height: height,
            border: getBorder(),
            display: "flex",
            // flexDirection: "column",
            flexWrap: "wrap",
            position: "relative",
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: width,
            position: "absolute",
            top: dTop,
            left: dLeft,
            right: dRight,
            bottom: dBottom,
          }}
          onDrop={(e) => {
            e.stopPropagation();
            const itemJson = e.dataTransfer.getData("data"); // Retrieve the dragged data
            const item = JSON.parse(itemJson);
            const input = {
              ...item.data,
              uid: generateUniqueId(),
            };

            let contents = getContentFromKeys(itemKey);

            let updatedContent = contents?.map((j) => {
              if (j.uid == uid) {
                const accfind = j?.accessory?.find((jk) => jk.id == pId);
                console.log(accfind, "accfind");

                for (let index = 0; index < accfind?.list?.length; index++) {
                  const element = accfind?.list[index];
                  if (element.id === id) {
                    element["content"] = input;
                  }
                }
              }

              return j;
            });
            setContentFromKeys(itemKey, updatedContent);
          }}
          onTouchEnd={(e) => {
            e.stopPropagation();
            if (!e.changedTouches || e.changedTouches.length === 0) return;
            
            // Get the current drag data from the context
            if (!dragDataRef.current) return;
            
            try {
              const item = dragDataRef.current;
              const input = {
                ...item.data,
                uid: generateUniqueId(),
              };

              let contents = getContentFromKeys(itemKey);

              let updatedContent = contents?.map((j) => {
                if (j.uid == uid) {
                  const accfind = j?.accessory?.find((jk) => jk.id == pId);
                  console.log(accfind, "accfind");

                  for (let index = 0; index < accfind?.list?.length; index++) {
                    const element = accfind?.list[index];
                    if (element.id === id) {
                      element["content"] = input;
                    }
                  }
                }

                return j;
              });
              setContentFromKeys(itemKey, updatedContent);
            } catch (err) {
              console.error("Error with drag data:", err);
            }
          }}
          onTouchMove={handleTouchMove}
          data-droppable="true"
          data-id={id}
          data-parent-id={pId}
        >
          {item?.content &&
            downloadAs != "cutout-png=" &&
            renderSwitches(item?.content?.accessory)}
          {!downloadAs && item?.content && (
            <div
              className="absolute -top-6 right-0 cursor-pointer "
              onClick={(e) => {
                e.stopPropagation();
                let contents = getContentFromKeys(itemKey);

                let updatedContent = contents?.map((j) => {
                  if (j.uid == uid) {
                    const accfind = j?.accessory?.find((jk) => jk.id == pId);
                    console.log(accfind, "accfind");

                    for (
                      let index = 0;
                      index < accfind?.list?.length;
                      index++
                    ) {
                      const element = accfind?.list[index];
                      if (element.id === id) {
                        element["content"] = null;
                      }
                    }
                  }

                  return j;
                });
                setContentFromKeys(itemKey, updatedContent);
              }}
            >
              <DeleteIcon />
            </div>
          )}
        </div>
      );
      // });
    }

    if (downloadAs == "cutout-png") {
      return;
    }

    if (type == "2") {
      const width = isDownloadMode ? 209 : getAccuratePixels(209);
      const height = isDownloadMode ? 209 : getAccuratePixels(209);

      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
    }

    if (type == "curtain-up") {
      // return list?.map((item) => {
      const width = isDownloadMode ? 188 : getAccuratePixels(188);
      const height = isDownloadMode ? 188 : getAccuratePixels(188);

      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
      // });
    }

    if (type == "curtain-down") {
      // return list?.map((item) => {
      const width = isDownloadMode ? 188 : getAccuratePixels(188);
      const height = isDownloadMode ? 188 : getAccuratePixels(188);
      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
      // });
    }

    if (type == "master") {
      const width = isDownloadMode ? 188 : getAccuratePixels(188);
      const height = isDownloadMode ? 188 : getAccuratePixels(188);

      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
      // });
    }

    if (type == "fan") {
      const width = isDownloadMode ? 188 : getAccuratePixels(188);
      const height = isDownloadMode ? 188 : getAccuratePixels(188);

      // return list?.map((item) => {
      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
      // });
    }

    if (type == "fan-volume-up") {
      const width = isDownloadMode ? 188 : getAccuratePixels(188);
      const height = isDownloadMode ? 188 : getAccuratePixels(188);

      // return list?.map((item) => {
      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
      // });
    }

    if (type == "fan-volume-down") {
      const width = isDownloadMode ? 188 : getAccuratePixels(188);
      const height = isDownloadMode ? 188 : getAccuratePixels(188);

      // return list?.map((item) => {
      return (
        <IconSwitch
          key={id}
          isDownloadMode={isDownloadMode}
          id={id}
          selectedIcons={selectedIcons}
          handleSetSelectIcon={handleSetSelectIcon}
          deleteSelectedicon={deleteSelectedicon}
          downloadAs={downloadAs}
          type={type}
          uid={uid}
          frame={frame}
          {...item}
        />
      );
      // });
    }
    if (type == "fan-dot") {
      const width = isDownloadMode ? 12 : getAccuratePixels(12);
      const height = isDownloadMode ? 12 : getAccuratePixels(12);

      // return list?.map((item) => {
      return (
        <div
          style={{
            position: "absolute",
            top: dTop,
            left: dLeft,
            right: dRight,
            bottom: dBottom,
          }}
          key={id}
        >
          <div
            className="bg-remove-expaction"
            style={{
              width: width,
              height: height,
              // border: isDownloadIcon ? "none" : "2px solid #f00",
              borderRadius: "50%",
              background: isDownloadPng ? "black" : " #6495ED",
            }}
          ></div>
        </div>
      );

      // });
    }

    if (type == "moduler_dot") {
      const width = isDownloadMode ? 20 : getAccuratePixels(20);
      const height = isDownloadMode ? 20 : getAccuratePixels(20);

      // return list?.map((item) => {
      return (
        <div
          style={{
            position: "absolute",
            top: dTop,
            left: dLeft,
            right: dRight,
            bottom: dBottom,
          }}
          key={id}
        >
          <div
            className="bg-remove-expaction"
            style={{
              width: width,
              height: height,
              // border: isDownloadIcon ? "none" : "2px solid #f00",
              borderRadius: "12%",
              border: isDownloadPng ? "1px solid black" : "1px solid #6495ED",
            }}
          ></div>
        </div>
      );
    }
  };

  const renderSwitches = (accessory) => {
    return accessory?.map((item) => {
      const gap = isDownloadMode ? 60 : getAccuratePixels(60);

      return (
        <div
          key={item?.id}
          style={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            // alignItems: "center",
            flexWrap: "wrap",
            // gap: gap + "px",
          }}
        >
          {item?.list?.map((i) => {
            return renderAccessory(i, item.id);
          })}
        </div>
      );
    });
  };

  if (type == "switch") {
    return renderSwitches(accessory);
  }

  if (type == "indian_socket") {
    return (
      <IndianSocket isDownloadMode={isDownloadMode} downloadAs={downloadAs} />
    );
  }

  if (type == "Knob") {
    return <Knob isDownloadMode={isDownloadMode} downloadAs={downloadAs} />;
  }

  if (type == "rj11") {
    return <Rj11 isDownloadMode={isDownloadMode} downloadAs={downloadAs} />;
  }

  if (type == "rj45") {
    return <Rj45 isDownloadMode={isDownloadMode} downloadAs={downloadAs} />;
  }

  if (type == "usb") {
    return <Usb isDownloadMode={isDownloadMode} downloadAs={downloadAs} />;
  }

  if (type == "tv_socket") {
    return <TvSocket isDownloadMode={isDownloadMode} downloadAs={downloadAs} />;
  }

  if (type == "universal_socket") {
    return (
      <UniversalSocket
        isDownloadMode={isDownloadMode}
        downloadAs={downloadAs}
      />
    );
  }

  if (type == "international_socket") {
    return (
      <InternationalSocket
        isDownloadMode={isDownloadMode}
        downloadAs={downloadAs}
      />
    );
  }

  return null;
}

export default Switch;
